import type { UserGroupMemberLookupStatus } from '@navio/nsdk';
import type { StepFlowStep } from 'noddi-ui-web';
import { z } from 'zod';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

export type AddMemberStepKey = 'number' | 'person' | 'settings';

/**
 * Who drives which car is deliberately not a step here: it is a decision per car that takes the car
 * off its current driver, so it belongs in the cars table rather than at the end of a click-through.
 */
export const getAddMemberSteps = (t: NotificationGroupOverviewTranslations): StepFlowStep[] => [
  { key: 'number', label: t.addMemberStepNumber, description: t.addMemberStepNumberDescription },
  { key: 'person', label: t.addMemberStepPerson, description: t.addMemberStepPersonDescription },
  { key: 'settings', label: t.addMemberStepSettings, description: t.addMemberStepSettingsDescription }
];

/** What the number step learned, carried to the steps that need it after that query is gone. */
export type AddMemberLookup = {
  phoneNumber: string;
  status: UserGroupMemberLookupStatus;
  displayName: string;
};

export type AddMemberDraft = {
  firstName: string;
  lastName: string;
  email: string;
};

export const EMPTY_ADD_MEMBER_DRAFT: AddMemberDraft = {
  firstName: '',
  lastName: '',
  email: ''
};

export const addMemberSettingsSchema = z.object({
  isAdmin: z.boolean(),
  sendSms: z.boolean()
});

export type AddMemberSettingsValues = z.input<typeof addMemberSettingsSchema>;

export const DEFAULT_ADD_MEMBER_SETTINGS: AddMemberSettingsValues = {
  isAdmin: false,
  sendSms: true
};
